module.exports = __webpack_public_path__ + "assets/img/email-cec04821.png";